'use strict';

var balcaoApp = angular.module('app.services');
balcaoApp.factory('anexoApi', anexoSrv);
anexoSrv.$inject = ['$resource', 'ConfigApp'];

function anexoSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/anexos',
        {  }, {
            baixarArquivo: {
                method: 'GET',
                isArray: false,
                url: ConfigApp.UrlApi + '/v1.0/anexos/:anexoId/chamados/:chamadoId/download',
                responseType: 'arraybuffer',
                interceptor: {
                    response: function (response) {
                        response.resource.headers = response.headers();
                        response.resource.data = response.data;
                        return response.resource;
                    }
                }
            }
        });
};



// WEBPACK FOOTER //
// ./src/services/anexos-api-service.js